// extracted by mini-css-extract-plugin
export var modal = "_gq-0";